class NotFoundError extends Error {
  constructor(message) {
    super()
    this.name = 'NotFoundError'
    this.message = message || 'Not found. Check your config'
  }
}

export default NotFoundError
